<template>
  <div v-if="userLoaded">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdminIndex',
  data: () => ({
    userLoaded: false
  }),
  async created () {
    await this.requestUserInfo()
    await this.requestAllOrganizations()
    this.userLoaded = true
  },
  methods: {
    ...mapActions(['requestUserInfo', 'requestAllOrganizations'])
  }
}
</script>
